export default __webpack_public_path__ + "static/Cloud-Infrastructure-170c46b314d8c88916a035c59d4bb127.webp";